import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import cn from 'classnames'
import AppBar from '@groovehq/internal-design-system/lib/components/AppBar/AppBar'
import { doShowChatAvailabilityModal } from 'actions/modals'
import { selectWidgetFromUrl } from 'ducks/widgets/selectors/widgets'
import { selectIsOfflineAgentsBotRunningForRoomFromUrl } from 'ducks/chat/selectors/botState'
import styles from './styles.less'

const variants = {
  existing: {
    type: 'warning',
    message:
      'Your live chat is currently enabled only for existing conversations.',
  },
  offline: {
    type: 'negative',
    message:
      'Your live chat is currently disabled for new & existing conversations.',
  },
  botsRunning: {
    type: 'warning',
    message: `The "No online ${app.t(
      'agent'
    )}" bot is currently running as no ${app.t('agents')} are online.`,
  },
}

const AvailabilityBar = () => {
  const widget = useSelector(selectWidgetFromUrl)
  const offlineBotRunning = useSelector(
    selectIsOfflineAgentsBotRunningForRoomFromUrl
  )
  const dispatch = useDispatch()
  const onEditVisibilityClick = useCallback(
    e => {
      dispatch(doShowChatAvailabilityModal())
      e.preventDefault()
    },
    [dispatch]
  )

  if (!widget || !widget.publishedSettings) return null
  const chatAvailability =
    widget.publishedSettings['chat.availability'] || 'online'
  if (!offlineBotRunning && chatAvailability === 'online') return null

  let availabilityMessage = variants[chatAvailability]
  let linkToEditVisibility = true

  if (offlineBotRunning && chatAvailability !== 'offline') {
    availabilityMessage = variants.botsRunning
    linkToEditVisibility = false
  }

  return (
    <AppBar
      type={availabilityMessage.type}
      closable={false}
      close={false}
      className={cn(styles.wrapper, styles[availabilityMessage.type])}
    >
      <span>{availabilityMessage.message}</span>{' '}
      {linkToEditVisibility && (
        <a className={styles.link} href="/" onClick={onEditVisibilityClick}>
          Edit visibility.
        </a>
      )}
    </AppBar>
  )
}

export default AvailabilityBar
